import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "variant", "space"];
import React, { forwardRef, memo } from 'react';
import { useChildrenValidation } from '../../hooks/useChildrenValidation';
import { Box } from '../Box';
import { Spacer } from '../Spacer';
import { TabMenuItem } from './TabMenuItem';
export var TabMenu = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'auto' : _ref$variant,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? 's' : _ref$space,
      styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  useChildrenValidation(children, 'Tab.Menu', TabMenuItem);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "grey.base",
    bg: "base.white"
  }, styleProps), /*#__PURE__*/React.createElement(Spacer, {
    space: space,
    fluid: true,
    itemsSized: variant,
    "data-test": "tab-menu"
  }, children));
}));
TabMenu.displayName = 'Tab.Menu';